import { Component, OnInit, Input } from '@angular/core';
import { StateType } from '../model/empty-state.model';
@Component({
  selector: 'monorepo-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss'],
})
export class EmptyStateComponent implements OnInit {
  @Input()
  statetype: StateType = StateType.UPLOAD;
  StateTypeEnum: any = StateType;
  constructor() {}
  ngOnInit(): void {}
}
